export default {
    namespaced: true,
    state: {
        pageData: {} // 多页面隔离：每个页面用唯一 key
    },
    mutations: {
        setPageData(state, {
            key,
            data
        }) {
            state.pageData[key] = data;
        }
    },
    actions: {
        updatePageData({
            commit
        }, payload) {
            commit('setPageData', payload);
        }
    }
};
